import { tabs } from 'app/config/app'
import { useAtomValue, useSetAtom } from 'jotai'
import { useLocation, useNavigate } from 'react-router-dom'
import { isModifiedAtom, isShowPopupGlobalAtom, pathChoiceAtom } from 'store'

export default function useChangeTab() {
  const navigate = useNavigate()
  const isModified = useAtomValue(isModifiedAtom)
  const setShowPopupGlobal = useSetAtom(isShowPopupGlobalAtom)
  const setPathChoice = useSetAtom(pathChoiceAtom)
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const tabValue = searchParams.get('tab') as string

  const handleMultipleChangeTab = (pathname: string) => {
    if (isModified && tabValue === tabs.HOSPITAL_SETTING) {
      setShowPopupGlobal(true)
      setPathChoice(pathname)
    } else {
      setShowPopupGlobal(false)
      navigate(pathname)
    }
  }

  return handleMultipleChangeTab
}
